/* eslint-disable */
import { destroy } from "redux-form";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  loadCatalogoSuccess,
  procesarNuevaMatriculaSuccess,
  LOAD_CATALOGO_NUEVA_MATRICULA,
  DESTROY_NUEVA_MATRICULA_FORM,
  PROCESAR_NUEVA_MATRICULA,
} from "../../redux/actions/nuevaMatriculaActions";
import {
  ROUTE_CATALOGO,
  ROUTE_MATRICULA,
  ROUTE_NOTIFICACION,
} from "../../utils/constants";
import toAPIPath from "../../utils/locationResolver";
import { buildEnrollmentInvitationEmail, buildEnrollmentInvitationExistingFamilyEmail } from "../../utils/emailTemplates";

export function* getCatalogo(payload) {
  const { api, token } = payload;
  try {
    const catalogo = yield call(
      api.get,
      toAPIPath([ROUTE_CATALOGO, `findOne?access_token=${token}`])
    );
    yield put(loadCatalogoSuccess(catalogo));
  } catch (err) {
    throw err;
  }
}

export function* destroyForm(payload) {
  const { form } = payload;
  try {
    yield put(destroy(form));
  } catch (err) {
    /* eslint-disable-next-line */
    console.err("An error ocurred deleting the matricula form: ", err);
  }
}

export function* postNotificarEncargado(payload) {
  const { api, token, notificacion } = payload;
  try {
    yield call(
      api.post,
      toAPIPath([`${ROUTE_NOTIFICACION}?access_token=${token}`]),
      notificacion
    );
  } catch (err) {
    throw err;
  }
}

export function* postMatricula(payload) {
  const { api, data } = payload;
  const { nuevoAlumno, token } = data;
  try {
    const newStudent = yield call(
      api.post,
      toAPIPath([`${ROUTE_MATRICULA}/nueva?access_token=${token}`]),
      nuevoAlumno
    );

    const correosDeLosPadres = [];
    if (nuevoAlumno.padre.email) {
      correosDeLosPadres.push({
        email: nuevoAlumno.padre.email,
        password: newStudent.contraseniaPadre,
      });
    }
    if (nuevoAlumno.madre.email) {
      correosDeLosPadres.push({
        email: nuevoAlumno.madre.email,
        password: newStudent.contraseniaMadre,
      });
    }

    const nuevosPadres =
      newStudent.contraseniaPadre && newStudent.contraseniaMadre;
    let notificacionUsuario = null;
    const notificaciones = [];
    if (nuevosPadres) {
      correosDeLosPadres.forEach((padre) => {
        notificacionUsuario = buildEnrollmentInvitationEmail(padre.email, padre.email, padre.password, nuevoAlumno.nombre);
        notificaciones.push(notificacionUsuario);
      });
    } else {
      correosDeLosPadres.forEach((padre) => {
        notificacionUsuario = buildEnrollmentInvitationExistingFamilyEmail(padre.email, nuevoAlumno.nombre);
        notificaciones.push(notificacionUsuario);
      });
    }

    yield all(
      notificaciones.map((notificacion) =>
        call(postNotificarEncargado, {
          api,
          token,
          notificacion,
        })
      )
    );

    yield put(procesarNuevaMatriculaSuccess());
  } catch (err) {
    throw err;
  }
}

export default function* rootSaga() {
  yield takeLatest(LOAD_CATALOGO_NUEVA_MATRICULA, getCatalogo);
  yield takeLatest(DESTROY_NUEVA_MATRICULA_FORM, destroyForm);
  yield takeLatest(PROCESAR_NUEVA_MATRICULA, postMatricula);
}
